import React from "react";
import {injectIntl} from "react-intl";
import styles from "./_StandardText.module.scss";
const StandardText = ({text, values = {}, intl, children}) => (
    <div className={styles.text}>{text ? intl.formatMessage({id: text}, values) : children}</div>
);
export default injectIntl(StandardText);